import React from "react";
import EmployeeForm from "./EmployeeForm";

export default function EditEmployee() {
    return(
      <EmployeeForm type={"Edit"}/>
    )
}